<div class="grid pr-2 pl-2 lg:pr-4 lg:pl-4 justify-content-between">
  <ng-content></ng-content>
</div>